<template>
	<div class="opening-wrap p-4 bg-[#d8caa8] rounded-lg">
		<div class="opening-page">
			<div class="bg"><img src="@/assets/img/opening/opening_bg.png" class="anime-fuwafuwa"></div>
			<div class="btn-area anime-poyopoyo">
				<button @click="next(1)"><img src="@/assets/img/opening/btn_start.png"></button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "CommonHead",
	computed: {
		step() {
			return this.$store.getters.step
		},
		count() {
			return this.$store.getters.count
		}
	},
	methods: {
		next(step) {
			this.$store.dispatch('next', step)
		}
	}
}
</script>

<style lang="scss" scoped>
div.opening-wrap {
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	div.opening-page {
		position: relative;
		/* アニメーションには関係ない見た目のスタイル */
		.btn-area {
			position: absolute;
			bottom: 160px;
			left: 0;
			width: 100%;
			z-index: 1;
			display: flex;
			justify-content: center;
			align-items: center;
			@media screen and (max-width: 480px) {
				position: relative;
				bottom: 0;
				max-width: 240px;
				margin: 0 auto;
			}
		}
		/* 回転するアニメーション */
		@keyframes fuwafuwa {
			0%, 100% {
				transform: translateY(0);
			}
			50% {
				transform: translateY(-20px);
			}
		}
		@keyframes poyopoyo {
			0%, 40%, 60%, 80% {
				transform: scale(1.0);
			}
			50%, 70% {
				transform: scale(0.95);
			}
		}
		.anime-fuwafuwa {
			animation: 5s fuwafuwa infinite;
		}
		.anime-poyopoyo {
			animation-timing-function: ease-in-out;
			animation-iteration-count: infinite;
			animation-direction: alternate;
			animation-duration: 1.5s;
			animation-name: poyopoyo;
		}
	}
}

</style>